import type { Address } from 'viem'
import { RelayExecutionStatus } from './types'

/**
 * Fake address for a chain's native currency used by Funkit
 */
export const FUNKIT_NATIVE_TOKEN =
  '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee' satisfies Address

/**
 * Fake address for a chain's native currency used by Relay
 */
export const RELAY_NATIVE_TOKEN =
  '0x0000000000000000000000000000000000000000' satisfies Address

/**
 * Wallet that receives the app fees collected by Relay
 */
export const FUN_RELAY_REVENUE_WALLET =
  '0xb61562d83aEC43a050A06BED12Ac2bD8f9BFfd5E' satisfies Address

/**
 * Referred field in Relay quote
 */
export const FUN_RELAY_REFERRER = 'funxyz'

/**
 * Buffer added to Relay's time estimate (which sometimes is 0)
 */
export const RELAY_QUOTE_CHECKOUT_TIME_BUFFER_MS = 25_000 // 25 seconds

export const RELAY_TERMINAL_STATUSES: RelayExecutionStatus[] = [
  RelayExecutionStatus.REFUND,
  RelayExecutionStatus.FAILURE,
  RelayExecutionStatus.SUCCESS,
]
